const InReviewResellerIcon = ({ ...props }) => {
  return (
    <svg
      width="106"
      height="22"
      viewBox="0 0 106 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="22" height="22" rx="11" fill="#FF9900" />
      <path
        d="M7 6H15L7 16H15L7 6Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M29.864 7.06H31.496V16H29.864V7.06ZM35.2156 7.06H36.4876L40.7476 12.796V7.06H42.3796V16H41.0956L36.8476 10.156V16H35.2156V7.06ZM50.2429 7.06H53.5669C54.1749 7.06 54.7149 7.172 55.1869 7.396C55.6589 7.612 56.0229 7.932 56.2789 8.356C56.5429 8.78 56.6749 9.288 56.6749 9.88C56.6749 10.488 56.5309 11.012 56.2429 11.452C55.9549 11.884 55.5589 12.204 55.0549 12.412L57.1069 16H55.2589L53.4109 12.7H51.8749V16H50.2429V7.06ZM53.5909 11.26C54.0309 11.26 54.3829 11.136 54.6469 10.888C54.9109 10.632 55.0429 10.296 55.0429 9.88C55.0429 9.464 54.9109 9.132 54.6469 8.884C54.3829 8.628 54.0309 8.5 53.5909 8.5H51.8749V11.26H53.5909ZM60.1765 7.06H66.1165V8.5H61.8085V10.792H65.8765V12.232H61.8085V14.56H66.1165V16H60.1765V7.06ZM68.5812 7.06H70.3572L72.6372 13.936L74.9052 7.06H76.6812L73.5732 16H71.7012L68.5812 7.06ZM79.6804 7.06H81.3124V16H79.6804V7.06ZM85.032 7.06H90.972V8.5H86.664V10.792H90.732V12.232H86.664V14.56H90.972V16H85.032V7.06ZM93.4367 7.06H95.1887L96.8447 13.78L98.5847 7.06H100.277L102.005 13.78L103.661 7.06H105.413L103.013 16H101.141L99.4247 9.568L97.7087 16H95.8367L93.4367 7.06Z"
        fill="#FF9900"
      />
    </svg>
  );
};

export default InReviewResellerIcon;
